import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  IconButton,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import CustomButton from "../constant/commonButton";

const styles = {
  dialogTitle: {
    textAlign: "center",
    position: "relative",
  },
  closeIcon: {
    position: "absolute",
    right: 8,
    top: 8,
    // color: (theme) => theme.palette.grey[500],
  },
  successIcon: {
    color: "green",
    fontSize: 40,
  },
  errorIcon: {
    color: "red",
    fontSize: 40,
  },
  dialogContent: {
    textAlign: "center",
  },
  dialogButton: {
    backgroundColor: "#08234d",
    color: "#fff",
    marginBottom: "20px",
    borderRadius: "20px",
  },
};

const CommonDialog = ({
  open,
  isSuccess,
  onClose,
  redirectPath,
  //   titleSuccess = "Success!",
  //   titleError = "Error!",
  messageSuccess = "Your operation was successful!",
  messageError = "There was an error. Please try again.",
}) => {
  const navigate = useNavigate();

  const handleAddMore = () => {
    if (redirectPath) {
      navigate(redirectPath);
    } else {
      onClose();
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={styles.dialogTitle}>
        {/* Close Icon */}
        <IconButton aria-label="close" onClick={onClose} sx={styles.closeIcon}>
          <CloseIcon />
        </IconButton>
        {isSuccess ? (
          <CheckCircleIcon sx={styles.successIcon} />
        ) : (
          <CancelIcon sx={styles.errorIcon} />
        )}
      </DialogTitle>
      <DialogContent sx={styles.dialogContent}>
        <Typography variant="body1" gutterBottom>
          {isSuccess ? messageSuccess : messageError}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center", marginBottom: "20px" }}>
        <CustomButton
          text={isSuccess ? "Add More" : "Retry"}
          variant="contained"
          size="small"
          onClick={isSuccess ? handleAddMore : onClose}
          buttonStyle={styles.dialogButton}
        >
          {isSuccess ? "Add More" : "Retry"}
        </CustomButton>

        {/* <Button
          onClick={isSuccess ? handleAddMore : onClose}
          variant="contained"
          sx={styles.dialogButton}
        >
          {isSuccess ? "Add More" : "Retry"}
        </Button> */}
      </DialogActions>
    </Dialog>
  );
};

export default CommonDialog;
